<div class="container single-view" id="view-user">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/users" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'USERS.BTN_BACK_TO_USER' | translate }}</a>
      </div>
      <div class="switch-wr">
        @if (!user.isAnonymised && allowModifyUser) {
          <p-selectButton
            class="status-switch"
            [class.status-active]="stateInitialValue === true"
            [options]="stateOptions"
            optionLabel="displayLabel"
            optionValue="value"
            [allowEmpty]="false"
            [(ngModel)]="stateInitialValue"
            (onChange)="onStateChange($event)">
            <ng-template #item let-option>
              <span
                class="status-option"
                [attr.data-testid]="'btn-' + option.label">
                <i class="pi pi-check status-check" aria-hidden="true"></i>
                <span>{{ option.displayLabel }}</span>
              </span>
            </ng-template>
          </p-selectButton>
        }
      </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="user-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{
              'USER_SINGLE_VIEW.USER_DETAILS' | translate }}
            </h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                <span data-testid="user-name">
                  @if (user.firstName) {
                    {{ user.firstName | defaultValue }}{{ ' ' }}
                  }
                  @if (user.lastName) {
                    {{ user.lastName | defaultValue }}
                  }
                </span>

                @if (user.isActive) {
                  <span data-testid="user-status" class="tag tag-green">
                    {{ 'ENUMS.ACTIVE' | translate }}
                  </span>
                }

                @if (!user.isActive) {
                  <span data-testid="user-status" class="tag tag-red">
                    {{ 'ENUMS.INACTIVE' | translate }}
                  </span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="w-100 flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap">
            <span data-testid='user-role' class="flex items-center mr-2" pTooltip="{{ 'USER_SINGLE_VIEW.TOOLTIP_ROLES' | translate }}" tooltipPosition="top"><i class="icon icon-roles mr-1"></i>{{ this.user.roleName}}</span>
            <span data-testid='user-lastlogin' class="flex items-center mr-2" pTooltip="{{ 'USER_SINGLE_VIEW.TOOLTIP_LAST_LOGIN' | translate }}" tooltipPosition="top"><i class="icon icon-clock mr-1"></i>{{user.latestLogin | date: 'dd-MM-yyyy HH:mm' | defaultValue }}</span>
          </div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (userHasMfaEnabled && !user.isAnonymised) {
              <button data-testid="user-unerollmfa-btn" class="btn outline-btn danger-btn" (click)="onConfirmUnenrollMfa()">
                {{ 'YOUR_ACCOUNT.BTN_UNENROLL_MFA' | translate }}
              </button>
            }

            @if (allowModifyUser) {
              <button data-testid="user-change-password-btn" class="btn outline-btn" [disabled]="user.isAnonymised" (click)="onOpenChangePasswordModalbox()">
                {{ 'USER_SINGLE_VIEW.BTN_OPEN_CHANGE_PASSWORD_MODALBOX' | translate }}
              </button>
            }

            @if (allowModifyUser) {
              <button data-testid="user-edit-btn" class="btn primary-btn" [disabled]="user.isAnonymised" (click)="goToEditUser()">
                {{ 'USER_SINGLE_VIEW.BTN_EDIT' | translate }}
              </button>
            }

            @if (delete) {
              <button data-testid="user-delete-btn" id="btn-delete-user" class="btn red-btn" (click)="dialog.show()" [disabled]="user.isAnonymised">
                {{ 'USERS.BTN_DELETE' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12">
                <h4 data-testid="user-details">{{ 'USER_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">

                  <dt data-testid="user-username-label" class="label grid-cols-1 pt-3">{{ 'USER_SINGLE_VIEW.USERNAME' |
                    translate }}</dt>
                  <dd data-testid="user-username" class="value pt-3 pb-3">{{user.username | defaultValue }}</dd>

                  <dt data-testid="user-mail-label" class="label grid-cols-1 pt-3">{{ 'USER_SINGLE_VIEW.EMAIL' |
                    translate }}</dt>
                  <dd data-testid="user-mail" class="value pt-3 pb-3">{{user.email | defaultValue }}</dd>

                  <dt data-testid="user-firstname-label" class="label grid-cols-1 pt-3">{{ 'USER_SINGLE_VIEW.FIRST_NAME'
                    | translate }}</dt>
                  <dd data-testid="user-firstname" class="value pt-3 pb-3">{{user.firstName | defaultValue }}</dd>

                  <dt data-testid="user-romanisedfirstname-label" class="label grid-cols-1 pt-3">{{
                    'USER_SINGLE_VIEW.ROMANIZED_FIRST_NAME' | translate }}</dt>
                  <dd data-testid="user-romanisedfirstname" class="value pt-3 pb-3">{{user.romanisedFirstName |
                    defaultValue }}</dd>

                  <dt data-testid="user-lastname-label" class="label grid-cols-1 pt-3">{{ 'USER_SINGLE_VIEW.LAST_NAME' |
                    translate }}</dt>
                  <dd data-testid="user-lastname" class="value pt-3 pb-3">{{user.lastName | defaultValue }}</dd>

                  <dt data-testid="user-romanisedlastname-label" class="label grid-cols-1 pt-3">{{
                    'USER_SINGLE_VIEW.ROMANIZED_LAST_NAME' | translate }}</dt>
                  <dd data-testid="user-romanisedlastname" class="value pt-3 pb-3">{{user.romanisedLastName |
                    defaultValue }}</dd>

                  <dt data-testid="user-language-label" class="label grid-cols-1 pt-3">{{ 'USER_SINGLE_VIEW.LANGUAGE' |
                    translate }}</dt>
                  <dd data-testid="user-language" class="value pt-3 pb-3">{{user.languageCode | languagePipe |
                    defaultValue }}</dd>

                  <dt data-testid="user-mfaenabled-label" class="label grid-cols-1 pt-3">{{
                    'USER_SINGLE_VIEW.HAS_MFA_ENABLED' | translate }}</dt>
                  <dd data-testid="user-mfaenabled" class="value pt-3 pb-3">{{user.isMfaEnabled | friendlyBoolean }}
                  </dd>

                  <dt data-testid="user-createdon-label" class="label grid-cols-1 pt-3">{{ 'USER_SINGLE_VIEW.CREATED_ON'
                    | translate }}</dt>
                  <dd data-testid="user-createdon" class="value pt-3 pb-3">
                    {{user.createdOn | date: 'dd-MM-yyyy HH:mm' | defaultValue }}
                  </dd>

                  <dt data-testid="user-createdby-label" class="label grid-cols-1 pt-3">{{ 'USER_SINGLE_VIEW.CREATED_BY'
                    | translate }}</dt>
                  <dd data-testid="user-createdby" class="value pt-3 pb-3">
                    @if (user.createdById) {
                      <a [routerLink]="['/users/', user.createdById]" class="inline-flex items-center link">
                        {{ user.createdByFullName | defaultValue }}
                      </a>
                    } @else {
                      {{ user.createdByFullName | defaultValue }}
                    }
                  </dd>

                  <dt data-testid="user-updatedon-label" class="label grid-cols-1 pt-3">{{ 'USER_SINGLE_VIEW.UPDATED_ON'
                    | translate }}</dt>
                  <dd data-testid="user-updatedon" class="value pt-3 pb-3">
                    {{user.updatedOn | date: 'dd-MM-yyyy HH:mm' | defaultValue }}
                  </dd>

                  <dt data-testid="user-updatedby-label" class="label grid-cols-1 pt-3">{{ 'USER_SINGLE_VIEW.UPDATED_BY'
                    | translate }}</dt>
                  <dd data-testid="user-updatedon" class="value pt-3 pb-3">
                    @if (user.updatedById) {
                      <a [routerLink]="['/users/', user.updatedById]" class="inline-flex items-center link">
                        {{ user.updatedByFullName | defaultValue }}
                      </a>
                    } @else {
                      {{ user.updatedByFullName | defaultValue }}
                    }
                  </dd>
                </dl>
              </div>
            </section>

            <section class="row">
              <div class="col-12 mt-5 mb-3">
                <h4 data-testid="user-markets-details">{{ 'USER_SINGLE_VIEW.USER_MARKETS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
              </div>
              <div class="col-12">
                <p-table [value]="marketsAssignedTo" #dMarketsAssignedTable>
                  <ng-template #header>
                    <tr>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'USER_SINGLE_VIEW.TH_NAME' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'USER_SINGLE_VIEW.TH_CODE' | translate }}</span>
                        </div>
                      </th>
                  </ng-template>
                  <ng-template #body let-market>
                    <tr>
                      <td>
                        <span class="p-column-title">{{ 'USER_SINGLE_VIEW.TH_NAME' | translate }}:</span>
                        {{ market.name | defaultValue }}
                      </td>
                      <td>
                        @if (canViewMarkets) {
                          <a [routerLink]="['/markets/', market.id]" class="inline-flex items-center link">
                            {{ market.code | defaultValue }}
                          </a>
                        } @else {
                          {{ market.code | defaultValue }}
                        }
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template #emptymessage>
                    <tr>
                      <td colspan="5">{{ 'USER_SINGLE_VIEW.NO_DATA_MARKETS' | translate }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </section>

            <section class="row">
              <div class="col-12 mt-3 mb-3">
                <h4 data-testid="user-reitalers-details">{{ 'USER_SINGLE_VIEW.USER_RETAILERS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
              </div>
              <div class="col-12">
                <p-table [value]="retailersAssignedTo" #dtRetailersAssignedTable>
                  <ng-template #header>
                    <tr>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'USER_SINGLE_VIEW.TH_NAME' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'USER_SINGLE_VIEW.TH_CODE' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'USER_SINGLE_VIEW.TH_CITY' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'USER_SINGLE_VIEW.TH_COUNTRY' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'USER_SINGLE_VIEW.TH_MARKET' | translate }}</span>
                        </div>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-retailer>
                    <tr>
                      <td>
                        <span class="p-column-title">{{ 'USER_SINGLE_VIEW.TH_NAME' | translate }}:</span>
                        {{ retailer.name | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'USER_SINGLE_VIEW.TH_CODE' | translate }}:</span>
                        @if (canViewRetailers) {
                          <a [routerLink]="['/retailers/', retailer.id]" class="inline-flex items-center link">
                            {{ retailer.code | defaultValue }}
                          </a>
                        } @else {
                          {{ retailer.code | defaultValue }}
                        }
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'USER_SINGLE_VIEW.TH_CITY' | translate }}:</span>
                        {{ retailer.city | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'USER_SINGLE_VIEW.TH_COUNTRY' | translate }}:</span>
                        {{ retailer.isoCountry | CountryTransformPipe | async | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'USER_SINGLE_VIEW.TH_MARKET' | translate }}:</span>
                        {{ retailer.marketName | defaultValue }}
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template #emptymessage>
                    <tr>
                      <td colspan="5">{{ 'USER_SINGLE_VIEW.NO_DATA_RETAILERS' | translate }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </section>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Confirmation: state change -->
<p-confirmDialog key="confirm-state-change-dialog" (onHide)="stateInitialValue = user.isActive">
  <ng-template pTemplate="header">
    <span class="p-dialog-title">{{ 'MODALBOXES.TITLE_CONFIRM_STATE_CHANGE' | translate }}</span>
  </ng-template>
  <ng-template pTemplate="message">
    <div class="flex flex-column align-items-center w-full gap-3">
      <p [innerHTML]="sanitizedConfirmMessage"></p>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button id="btn-cancel-change" type="button" class="btn outline-btn" (click)="onCancelStateChange()">{{
      'MODALBOXES.BTN_CANCEL_STATE_UPDATE' | translate }}</button>
    <button id="btn-confirm-update" type="button" class="btn primary-btn" (click)="onConfirmStateChange()">{{
      'MODALBOXES.BTN_CONFIRM_STATE_UPDATE' | translate }}</button>
  </ng-template>
</p-confirmDialog>

<!-- Modalbox: update password -->
<p-dialog [header]="'MODALBOXES.TITLE_CHANGE_PASSWORD' | translate" [(visible)]="displayChangePasswordModalbox" modal="true" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false">
  <form class="mt-0" [formGroup]="updatePasswordForm">
    <div class="row">

      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <label class="block text-sm" for="new-pass">{{ 'YOUR_ACCOUNT.NEW_PASSWORD' | translate }} <i
            class="icon icon-info" pTooltip="{{ 'YOUR_ACCOUNT.PASSWORD_TOOLTIP' | translate }}"
            tooltipPosition="top"></i></label>
        <div class="password-field-wr">
          <input [type]="showPassword ? 'text' : 'password'" id="new-pass" formControlName="password" tabindex="18" autocomplete="off" class="password-field">
          <button type="button" class="btn-icon-only btn-icon eye-toggle" [ngClass]="showPassword ? 'icon-eye-hide' : 'icon-eye-display'" (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"></button>
        </div>
        @if (
          updatePasswordForm.get('password')?.invalid &&
          (updatePasswordForm.get('password')?.dirty || updatePasswordForm.get('password')?.touched)
        ) {
          @if (updatePasswordForm.get('password')?.hasError('required')) {
            <small class="p-error">
              {{ 'YOUR_ACCOUNT.VALIDATE_PASSWORD' | translate }}
            </small>
          }
          @if (updatePasswordForm.get('password')?.errors?.['invalidPassword']) {
            <small class="p-error">
              {{ 'YOUR_ACCOUNT.FORMAT_PASSWORD' | translate }}
            </small>
          }
        }
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <label class="block text-sm" for="confirm-paswords">{{ 'YOUR_ACCOUNT.REPEAT_PASSWORD' | translate }}</label>
        <div class="password-field-wr">
          <input data-testid="confirm-password" [type]="showConfirmPassword ? 'text' : 'password'"
            formControlName="confirmPassword" tabindex="19" autocomplete="off" class="password-field">
          <button data-testid="confirm-password-toggle" type="button" class="btn-icon-only btn-icon eye-toggle"
            [ngClass]="showConfirmPassword ? 'icon-eye-hide' : 'icon-eye-display'" (click)="toggleConfirmPasswordVisibility()"
            [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'"></button>
        </div>
        @if (
          updatePasswordForm.get('confirmPassword')?.touched &&
          (updatePasswordForm.get('confirmPassword')?.invalid || updatePasswordForm.get('confirmPassword')?.dirty)
        ) {
          @if (updatePasswordForm.get('confirmPassword')?.errors?.['passwordMismatch']) {
            <small class="p-error">
              {{ 'YOUR_ACCOUNT.VALIDATE_PASSWORD_MATCH' | translate }}
            </small>
          }

          @if (
            !updatePasswordForm.get('confirmPassword')?.errors?.['passwordMismatch'] &&
            updatePasswordForm.get('confirmPassword')?.hasError('required')
          ) {
            <small class="p-error">
              {{ 'YOUR_ACCOUNT.VALIDATE_CONFIRM_PASSWORD' | translate }}
            </small>
          }
        }
      </div>

    </div>
  </form>
  <ng-template #footer>
    <button id="btn-cancel-change-password" type="button" class="btn outline-btn" (click)="onCancelChangePassword()">{{
      'MODALBOXES.BTN_CANCEL_CHANGE_PASSWORD' | translate }}</button>
    <button id="btn-update-password" class="mt-auto btn primary-btn" [disabled]="updatePasswordForm.invalid"
      (click)="onSubmitChangePasswordForm()">{{ 'MODALBOXES.BTN_CHANGE_PASSWORD' | translate }}</button>
  </ng-template>
</p-dialog>

<!-- MFA: unenroll device -->
<p-dialog [(visible)]="displayMfaUnenrollModalbox" [header]="'MODALBOXES.TITLE_UNENROLL_MFA' | translate" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false">
  <div>
    <p>{{ 'MODALBOXES.BODY_UNENROLL_MFA_CONFIRM' | translate }}</p>
    <div class="notice warning text-sm mt-4 mb-8">
      <p>{{ 'MODALBOXES.BODY_UNENROLL_MFA_WARNING' | translate }}</p>
    </div>
  </div>
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <button class="btn outline-btn" (click)="displayMfaUnenrollModalbox = false">
        {{ 'MODALBOXES.BTN_CANCEL' | translate }}
      </button>
      <button class="btn primary-btn p-button p-component" (click)="onUnenrollMfa()">
        {{ 'MODALBOXES.BTN_CONFIRM' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- Delete user -->
<dialog-reason #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_USER'" (onClose)="deleteUser($event)"></dialog-reason>
